import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
export function Hero() {
  return <section className="relative bg-brand-dark pt-12 pb-14 md:pt-20 md:pb-20 px-4 overflow-hidden" data-id="element-186" data-mp="9kjuoj1ugu11">
      <div className="absolute left-0 top-12 h-48 w-48 rounded-full border border-brand-primary/20 -translate-x-1/2 pointer-events-none" data-id="element-187" data-mp="4m8nyh6uizn1" />
      <div className="absolute right-0 bottom-16 h-64 w-64 rounded-full border border-brand-primary/15 translate-x-1/2 pointer-events-none" data-id="element-188" data-mp="128yxm77pblw0" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-189" data-mp="sbb0jammi2ao">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7
      }} className="flex justify-center mb-4" data-id="element-190" data-mp="s9ghy2ytqm9r">
          <img src="https://cdn.magicpatterns.com/uploads/s3FF58H7ACA9GwKpj9hE5W/WhatsApp_Image_2026-05-14_at_3.38.56_PM.jpg" alt="Mamá sin Caos — Lactancia y Calma" width={96} height={96} loading="eager" decoding="async"
        // @ts-ignore — fetchpriority is a valid HTML attr not yet typed in some React versions
        fetchpriority="high" className="w-16 md:w-20 h-auto rounded-full ring-4 ring-brand-cream/15 shadow-lg opacity-95" data-id="element-191" data-mp="384jssxvrzhse" />
        </motion.div>

        <motion.h1 className="max-w-4xl mx-auto text-4xl sm:text-5xl md:text-7xl font-serif text-brand-cream-light leading-[1.02] tracking-[-0.02em] mb-5" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-192" data-mp="359syxghq0b4r">
          El método para transitar tu lactancia con más calma,{' '}
          <span className="text-brand-accent" data-id="element-193" data-mp="s2b89zesml5o">sin dolor ni dudas.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-base sm:text-lg md:text-xl text-brand-cream/80 leading-relaxed mb-7 max-w-2xl mx-auto" data-id="element-194" data-mp="nat6j94y4gjn">
          Guiado por asesora certificada de lactancia para que puedas entender
          cada toma, desde el primer enganche al destete.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center mb-10" data-id="element-195" data-mp="11152jj4nizg2">
          <div className="text-center mb-4" data-id="element-196" data-mp="3htq0hyq6ywpm">
            <div className="flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1" data-id="element-197" data-mp="1xacfj35u5jt8">
              <span className="text-brand-primary/60 line-through text-base sm:text-lg" data-id="element-198" data-mp="21a4srt66ce4x">
                $89.000
              </span>
              <span className="text-brand-accent font-bold text-2xl sm:text-3xl md:text-4xl" data-id="element-199" data-mp="268fybrpfs2hc">
                $19.990 ARS
              </span>
            </div>
            <p className="text-brand-cream-light text-sm sm:text-base mt-1" data-id="element-200" data-mp="2g0c3tntuquvl">
              Precio de lanzamiento
            </p>
            <p className="text-brand-primary/80 text-xs sm:text-sm mt-2" data-id="element-201" data-mp="2kxknxtyk98zh">
              📥 Descarga digital inmediata — Accedés en segundos
            </p>
          </div>

          <a href="https://www.mamasincaos.store/cart/45320272543767:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout({
          value: 19990,
          currency: 'ARS',
          contentName: 'S.O.S. Lactancia Pack',
          contentIds: ['45320272543767']
        })} className="inline-flex items-center justify-center w-[90%] sm:w-auto min-h-[58px] px-7 sm:px-10 py-4 bg-brand-accent hover:bg-[#f0aea2] text-brand-darker text-lg sm:text-xl md:text-2xl font-bold rounded-2xl shadow-lg transition-all hover:scale-[1.02] animate-pulse-slow" data-id="element-202" data-mp="2tztte5ez2c60">
            🌿 QUIERO MI PACK AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-4 text-xs sm:text-sm text-brand-primary/80" data-id="element-203" data-mp="3hnxtsj48uirm">
            <span className="flex items-center gap-1.5" data-id="element-204" data-mp="3rfttfylzagxy">
              <ShieldCheck size={14} className="text-brand-gold" data-id="element-205" data-mp="3rhenzo8alzvt" /> Garantía 7
              días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-206" data-mp="3mnagn3v47pu7">
              <Lock size={14} className="text-brand-gold" data-id="element-207" data-mp="2yyr9irnsxj3p" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-208" data-mp="2u1hkhd4br9ge">
              <CreditCard size={14} className="text-brand-gold" data-id="element-209" data-mp="2tyvcjcdiurxn" /> Mercado Pago
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4
      }} className="relative max-w-3xl mx-auto mt-2 bg-brand-cream-light rounded-[2rem] p-4 md:p-8 shadow-2xl" data-id="element-210" data-mp="1e9ngb92atd36">
          <img src="https://cdn.magicpatterns.com/uploads/dU9nUBJCkVkB1iGCGVQWdx/Mockup_mama_sin_caos_(1).png" alt="S.O.S. Lactancia Pack Mockup" width={665} height={665} loading="eager" decoding="async"
        // @ts-ignore — fetchpriority is a valid HTML attr not yet typed in some React versions
        fetchpriority="high" className="w-full h-auto drop-shadow-2xl" data-id="element-211" data-mp="1sagbzx4c6e7v" />
        </motion.div>
      </div>
    </section>;
}